/**
 * @author varun
 * The modal dialog controller developed explicitely for the overlays. It will mostly listen to the events from other controllers when they were broadcast.
 * And do appropriate actions.
 */

var AppCtrlModalsModule = angular.module('AppCtrl.modals', ['AppCtrl.campaign.service', 'AppCtrl.ContactDetails.service', 'ngStorage', 'jv.Common.EmployeeSelect', 'jv.Common.Directives.HideOnBlur', 'jv.source.modal-adapter.service']);
AppCtrlModalsModule.service('modalHeights', function () {
    var DOM, Submodals = {};
    this.registerResizingNode = function (el) {
        DOM = $(el);
    };
    this.registerElement = function (el, name) {
        Submodals[name] = $(el);
    };

    function transformCssToInt(css) {
        return Number((css || '0px').match(/([0-9]+)px/)[1]) || 0;
    }

    function calculateParentHeight(currentParentHeight, currentSubHeight, nextSubHeight) {
        if (nextSubHeight === 0 && currentSubHeight !== 0) {
            nextSubHeight = currentSubHeight;
        } else if (currentSubHeight === 0 && nextSubHeight !== 0) {
            currentParentHeight = nextSubHeight;
        } else if (currentSubHeight === 0 && nextSubHeight === 0) {
            return currentParentHeight;
        }
        return nextSubHeight + (currentParentHeight - currentSubHeight);
    }

    this.shiftModal = function (from, to) {
        var currentHeight = transformCssToInt(DOM.css('height').toString()),
            from = transformCssToInt(Submodals[from].css('height')),
            to = transformCssToInt(Submodals[to].css('height')),
            nextHeight = calculateParentHeight(currentHeight, from, to);
        if (from > to) {
            DOM.addClass('to larger modal');
            DOM.removeClass('smaller');
        } else {
            DOM.addClass('to smaller modal');
            DOM.removeClass('larger');
        }
        if (isFinite(nextHeight)) {
            DOM.css('height', nextHeight);
        }
    };

    this.resizeModal = function (from, to) {
        var currentHeight = transformCssToInt(DOM.css('height').toString()),
            from = transformCssToInt(from),
            to = transformCssToInt(to),
            nextHeight = calculateParentHeight(currentHeight, from, to);
        if (isFinite(nextHeight)) {
            DOM.css('height', nextHeight);
        }
    };

    this.getSubModals = function (modal) {
        return Submodals[modal];
    };

    this.resizeParentOffset = function (headerValue, modalValue) {
        if (isFinite(headerValue + modalValue)) {
            DOM.css('height', headerValue + modalValue);
        }
    };
});

AppCtrlModalsModule.directive('jvModalHeight', ['modalHeights', function (heights) {
    return function (scope, el, attr) {
        heights.registerElement(el, attr.jvModalHeight);
    };
}]);
AppCtrlModalsModule.directive('jvModalResizeable', ['modalHeights', '$timeout', function (heights, $timeout) {
    return {
        restrict: 'A',
        link: function (sc, el, attr) {
            sc._resize = function () {
                var initial = $(el).css('height');
                $timeout(function () {
                    heights.resizeModal(initial, $(el).css('height'));
                }, 1);
            };
        }
    };
}]);
AppCtrlModalsModule.directive('jvModalParent', ['modalHeights', function (heights) {
    return {
        restrict: 'A',
        controller: function ($scope) {},
        link: function (sc, el, attr, controller) {
            heights.registerResizingNode(el);
            sc.$watch('activeModal', function (newVal, oldVal) {
                if (newVal === 'jvTPWConfigure') {
                    heights.resizeParentOffset($('.jv-modalHeader').outerHeight(true), heights.getSubModals('jvTPWConfigure').outerHeight(true));
                }
                if (newVal === oldVal) {
                    return;
                }
                heights.shiftModal(oldVal, newVal);
            });
        }
    };
}]);
// select2 in the modal dialog.
/**
 *  Using this directive you need three attributes.
 *      i)  'what-to-watch' :  (Array) REQUIRED ->  This will be used as the data for the select2.
 *      ii) 'what-to-change': (String) REQUIRED ->  What key should be changed in scope to reflect the change in select2.
 *      iii)'what-is-text'  : (String) REQUIRED ->  This will be used as the 'key' for displaying text in the object provided by 'what-to-watch'. (select2 uses 'text' as the key by default)
        iv) 'what-is-id': (String) OPTIONAL: -> default is id. you can specify your own id key for the select2.
        NOTE: if you are setting the default value for the select 2 then 'what-is-id' is required.
 */
AppCtrlModalsModule.directive('jvModalSelect2', function ($timeout, $filter) {

    var linker = function (scope, element, attribute) {

        var hiddenField = angular.element("<input style='" + attribute['style'] + "' type=\"hidden\" />");
        element.append(hiddenField);
        var firstRun = true;

        function buildResetObj() {
            var resetObj = {};
            if (angular.isDefined(attribute.jvPlaceholder)) {
                var possibles = $filter('filter')(scope.whatToWatch, function (value) {
                    return value[attribute.whatIsText] === attribute.jvPlaceholder;
                });
                if (possibles.length === 1) {
                    resetObj = possibles[0];
                } else {
                    resetObj[attribute.whatIsId] = '';
                    resetObj[attribute.whatIsText] = attribute.jvPlaceholder;
                }
            } else {
                if (firstRun && (scope.whatToChange != null) && angular.isDefined(scope.whatToChange)) {
                    resetObj = scope.whatToChange;
                } else {
                    resetObj = scope.whatToWatch[0];
                }
                firstRun = false;
            }
            return resetObj;
        }

        function renderSelect2() {
            // If there is another way you want to show the text.
            function format(item) {
                return item[attribute['whatIsText']];
            }

            var options = angular.copy(window._jvPluginDefaults.select2) || {};
            if (angular.isDefined(attribute.jvAllowClear)) {
                options.allowClear = !!attribute.jvAllowClear;
            }
            if (angular.isDefined(attribute.jvPlaceholder)) {
                options.placeholder = attribute.jvPlaceholder;
            }

            options.formatSelection = scope.formatSelection || format;
            options.formatResult = scope.formatResult || format;
            options.id = function (state) {
                return state[attribute['whatIsId']] || state['id'];
            };
            options.data = {
                results: scope['whatToWatch'],
                text: attribute['whatIsText']
            };
            options.initSelection = function (element, callback) {
                if (angular.isObject(scope.whatToChange)) {
                    callback(scope.whatToChange);
                } else if (options.allowClear && scope.whatToChange === null) {
                    callback(null);
                } else {
                    callback(scope.whatToWatch[0]);
                }
            };

            $(hiddenField).select2(options).on('change', function (event) {
                scope.$apply(function (scope) {
                    if (event.val === '' || angular.isUndefined(scope.whatToChange) || scope.whatToChange == null) {
                        scope.whatToChange = buildResetObj();
                    } else {
                        for (var i = 0, j = scope['whatToWatch'].length; i < j; i++) {
                            if (scope['whatToWatch'][i][attribute['whatIsId']] === event.val) {
                                scope['whatToChange'] = scope['whatToWatch'][i];
                                break;
                            }
                        }
                    }
                });
            });

            //              $(element).select2('val',scope['whatToWatch'][0]);
            //              scope['whatToChange'] = scope['whatToWatch'][0];
            // use time out for setting the value so you know that apply will always be applied.
            $timeout(function () {
                // set the initial value as the first one in the result list. Below doesnt work.
                //$(element).select2('data',scope['whatToWatch'][0]);
                //https://github.com/ivaynberg/select2/issues/49
                var newVal = buildResetObj();
                $(hiddenField).val(newVal);
                //                  scope['whatToChange'] = newVal;
                $(hiddenField).trigger('change');
            }, 300);

            if (scope['setToDisabled'] === 'true') {
                $(hiddenField).select2('disable');
            }
        }

        scope.$watch('whatToWatch', function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue.length > 0) {
                renderSelect2();
            }
        });
    };

    return {
        restrict: 'A',
        scope: {
            'whatToWatch': '=whatToWatch',
            'whatToChange': '=whatToChange',
            'whatIsText': '@whatIsText',
            'whatIsId': '@whatIsId',
            'setToDisabled': '@',
            'formatSelection': '=',
            'formatResult': '='
        },
        link: linker
    };
});

AppCtrlModalsModule.directive('jvModalSelect2Tags', ['modalHeights', '$timeout', function (heights, $timeout) {

    var tagSearchUrl = window.jvUrls.source + '/action/person/contactList';

    var linker = function (scope, element, attribute, ngModel) {
        var previous, newV;
        var tagsLocked = (element.attr('tagsLocked') === 'true');
        scope.$watch(ngModel, function (newValue, oldValue) {
            $(element).select2({
                tags: true,
                tokenSeparators: [','],
                minimumInputLength: 1,
                initSelection: function (element, callback) {
                    var data = [];
                    var tagArray = scope.talentpool.tags.split(',');
                    $.each(tagArray, function (index, value) {
                        data.push({
                            id: value,
                            text: value
                        });
                    });
                    callback(data);
                },
                // Allow manually entered text in drop down if tags are not locked
                createSearchChoice: function (term) {
                    if (!tagsLocked) {
                        return {
                            id: term.toLowerCase(),
                            text: term.toLowerCase()
                        };
                    }
                },
                ajax: {
                    url: tagSearchUrl,
                    dataType: 'json',
                    type: 'GET',
                    quietMillis: 100,
                    data: function (term) {
                        const result = {
                            prefix: term,
                            action: 'getTagsWithPrefix'
                        };

                        // Query parameters will be
                        // ?prefix=<term>&action=getTagsWithPrefix
                        return result;
                    },
                    results: function (data) {
                        var _tags = [];

                        // extract the id and text of each tag in the format expected by select2
                        $.each(data.data, function (index, value) {
                            _tags.push({
                                text: value.name,
                                id: value.id
                            });
                        });

                        return {
                            results: _tags
                        };
                    }

                }
            }).on('change', function (event) {
                ngModel.$setViewValue($(element).val());
                if(angular.isDefined(heights.getSubModals(scope.activeModal))){
                    if (angular.isUndefined(previous)) {
                        previous = heights.getSubModals(scope.activeModal).css('height');
                    }
                    newV = heights.getSubModals(scope.activeModal).css('height');
                    if (previous !== newV) {
                        heights.resizeModal(previous, newV);
                        previous = newV;
                    }
                }
                // whenever a tag is added or removed, need to recalculate the tagsLength variable used to check the maximum character size
                var tagsLength = 0;
                $.each($('#jv-tags').select2('data'), function (index, value) {
                    tagsLength += value.text.length;
                    if (index > 0) {
                        tagsLength += 1; // factor in the commas
                    }
                });

                scope.talentpool.tagsLength = tagsLength;
                scope.$apply();
            });
        });
    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: linker
    };
}]);

// date picker in the modal dialog.
AppCtrlModalsModule.directive('jvModalDatepicker', function () {
    // link
    function linker(scope, element, attribute) {

        $(element).datepicker({
            changeMonth: true,
            changeYear: true,
            minDate: '0d',
            buttonImage: window.jvUrls.source + '/__assets__/images/blue/icon-calendar.png', // use to be pointed at mikemac's local. this file might need to be added
            onSelect: function (time) {
                scope['whatToChange'] = time;
                // going from a jquery world
                scope.$apply();
            }
        });
        scope.$watch('whatToChange', function (newValue) {
            $(element).val(newValue);
        });
        $(element).val(scope['whatToChange']);
    }

    return {
        scope: {
            whatToChange: '=whatToChange'
        },
        restrict: 'A',
        link: linker
    };
});
AppCtrlModalsModule.directive('jvOnlyText', [function () {
    //detecting invalid keys.
    var keyToCheck = [188, 190];
    var maxCharacters = 250;

    function linker(scope, element, attr) {
        angular.element(element).on('keydown', function (event) {
            if (event.shiftKey && keyToCheck.indexOf(event.keyCode) !== -1) {
                return false;
            }
        });
        angular.element(element).on('keyup', function (event) {
            scope['show'] = false;
            if (angular.element(element).val().length > maxCharacters) {
                scope['show'] = true;
                scope['empty'] = false;
            }
            scope['model'] = angular.element(element).val().trim();
            scope.$apply();
        });
        //If model value exist.
        scope.$watch('model', function (newValue) {
            if (newValue === undefined) {
                return;
            }
            angular.element(element).val(scope['model']);
        });

    }
    return {
        restric: 'A',
        link: linker,
        scope: {
            model: '=model',
            show: '=show',
            empty: '=empty'
        }
    };
}]);
AppCtrlModalsModule.filter('statusPrint', function () {
    return function (status) {
        if (status === 'IN_PROGRESS') {
            return i18n['JV_CAMPAIGNMODAL_ACTIVE'];
        } else {
            return i18n['JV_CAMPAIGNMODAL_INACTIVE'];
        }
    };
});
AppCtrlModalsModule.value('MODAL_CONST', {
    strings: {
        'EMAILS_CONFIRMATION': i18n['JV_CAMPAIGNMODAL_EMAILS_SCHEDULED_FOR_CAMPAIGN_']
    },
    // template actions.
    Urls: {
        layout: 'campaign2/modals/selectLayout.html',
        webLayout: 'campaign2/modals/selectWebLayout.html',
        scheduleCampaign: 'campaign2/modals/scheduleCampaign.html',
        linkDetails: 'campaign2/modals/linkDetails.html',
        deleteScheduleEmail: 'campaign2/modals/deleteScheduleEmail.html',
        deleteEmail: 'campaign2/modals/deleteEmail.html',
        deleteCampaign: 'campaign2/modals/deleteCampaign.html',
        changeStatus: 'campaign2/modals/changeStatus.html',
        noScheduleEmail: 'campaign2/modals/noScheduleEmail.html',
        removeContacts: 'campaign2/modals/removeContacts.html',
        selectRequisitions: window.jvUrls.source + '/htm/contact2/modals/addToReq.html',
        selectWebCampaign: 'campaign2/modals/selectWebCampaign.html',
        selectEmailCampaign: 'campaign2/modals/selectEmailCampaign.html',
        configureWidget: 'campaign2/modals/TalentPoolWidget.html',
        selectFBAccount: 'campaign2/modals/selectAccount.html',
        campaignContacts: 'campaign2/modals/campaignContacts.html',
        noCampaignContacts: 'campaign2/modals/noCampaignContacts.html',
        removeCampaignContacts: 'campaign2/modals/removeContacts.html',
        getCampaignIframe: 'campaign2/modals/emailCampaignPreview.html',
        cloneCampaign: 'campaign2/modals/cloneCampaign.html'
        // accomodate the old ui.
        //selectRequisitions: window.jvUrls.source + '/action/person/applicantList'
    },

    // Action users.
    actionUrls: {
        //scheduleCampaign: window.jvUrls.source + '/action/crm/campaign/detail/{0}/contentSend/{1}',
        getRequisitions: window.jvUrls.jhire + '/action/requisitions/search',
        getWebCampaigns: window.jvUrls.jhire + '/action/campaignList',
        getTimeZone: window.jvUrls.source + '/action/sys/timezones',
        selectCampaign: window.jvUrls.source + '/action/person/contactList',
        // campaign eid and cid:templateid
        campaignContacts: window.jvUrls.source + '/action/crm/campaign/detail/{0}/content/{1}/contacts'
    }

});

/**
 * Service for modal dialogs to perform actions on these modals.
 * @param {Object} MODAL_CONST
 * @param {Object} makeAjaxCall
 */
AppCtrlModalsModule.service('actionModalService', ['MODAL_CONST', 'makeAjaxCall', 'campaignService', function (MODAL_CONST, makeAjaxCall, campaignService) {
    var actionModalService = {};

    // args should have 'data' property containing the object to send to the backend.
    actionModalService.scheduleCampaign = function (args, callback) {
        campaignService.scheduleCampaign(args, callback);
    };

    actionModalService.getRequisition = function (args, callback) {
        var requestObj = args || {};
        callback = (callback || angular.noop);
        args.maxResults = 10;
        // which page to get.
        args.page = args.page ? args.page : 0;
        requestObj.ajaxtype = 'getRequisitionsAction';
        requestObj.url = MODAL_CONST.actionUrls.getRequisitions;
        requestObj.requestType = 'GET';
        var _getRequisitions = makeAjaxCall(requestObj);
        _getRequisitions.then(function (results) {
            callback(results.data);
        });
    };

    // get the timezones for the modal dialogs.
    actionModalService.getTimeZones = function (args, callback) {
        campaignService.getTimeZone(args, callback);
    };

    actionModalService.selectCampaign = function (args, callback) {
        function processResults(html) {
            var largeElement = angular.element(html),
                goodResults = [],
                arrayOfTables = largeElement.find('table'),
                gridTable;
            angular.forEach(arrayOfTables, function (table) {
                if ($(table).hasClass('jv-tableGroup')) {
                    gridTable = $(table);
                }
            });
            var arrayOfTrs = gridTable.children();
            if (arrayOfTrs.length > 0 && arrayOfTrs[0].tagName === 'TBODY') {
                arrayOfTrs = arrayOfTrs.children();
            }
            angular.forEach(arrayOfTrs, function (Tr) {
                var campaignId = $(Tr).children("td[width=\"6%\"]").children("input[type=\"radio\"]").val();
                var campaignTitle = $(Tr).children("td[width=\"47%\"]").attr('title');
                var campaignStatus = $(Tr).children("td[width=\"26%\"]").attr('title');
                var campaignDate = $(Tr).children("td[width=\"20%\"]").attr('title');
                goodResults.push({
                    id: campaignId,
                    title: campaignTitle,
                    status: campaignStatus,
                    date: campaignDate
                });
            });
            var tmpElement = html.slice(html.indexOf("<ul class=\"jv-gridPageNav\" navigationType=\"CAMPAIGNS_GRID\">"));
            tmpElement = tmpElement.slice(0, tmpElement.indexOf('</ul>') + '</ul>'.length);
            tmpElement = angular.element(tmpElement);
            var textArr = tmpElement.children()[0].innerText.trim().match(/([0-9]+)-([0-9]+) of ([0-9]+)/);

            return {
                campaigns: goodResults,
                startNumber: Number(textArr[1]),
                endNumber: Number(textArr[2]),
                totalNumber: Number(textArr[3]),
                page: Math.ceil(Number(textArr[1]) / (Number(textArr[2] - Number(textArr[1]) + 1)))
            };
        }
        var requestObj = args || {};
        callback = (callback || angular.noop);
        // which page to get.
        args.page = args.page ? args.page : 0;
        args.q = args.q ? args.q : '';
        args.action = 'getCampaigns';
        args.identifier = 'addToCampaign';
        args.campaignStatus = -1;
        requestObj.ajaxtype = 'getCampaigns';
        requestObj.url = MODAL_CONST.actionUrls.selectCampaign.format(args.page);
        requestObj.requestType = 'POST';
        var _getRequisitions = makeAjaxCall(requestObj);
        _getRequisitions.then(function (results) {
            callback((processResults || angular.identity)(results.data));
        });
    };

    actionModalService.getCampaignContacts = function (args, callback) {
        args.ajaxtype = 'getCampaignContacts';
        args.url = MODAL_CONST.actionUrls.campaignContacts.format(args.campaignEid, args.templateEid);
        var _propertyToDelete = ['campaignEid', 'templateEid'];
        var _templateEid = args.templateEid;
        angular.forEach(_propertyToDelete, function (item) {
            delete args[item];
        });
        var _getCampaignContacts = makeAjaxCall(args);
        _getCampaignContacts.then(function (results) {
            results.data.templateEid = _templateEid;
            callback(results.data);
        });
    };


    return actionModalService;
}]);
/**
 * Service is used only to get the static htm templates from the backend.
 * @param {Object} MODAL_CONST
 * @param {Object} makeAjaxCall
 * @param {Object} $compile
 */
AppCtrlModalsModule.service('modalService', ['MODAL_CONST', 'makeAjaxCall', '$compile', 'sourceModalAdapter', function (MODAL_CONST, makeAjaxCall, $compile, sourceModalAdapter) {
    var modalService = {};

    //Initialize the modal utility. You must do it when you initialize the service otherwise nothing will work.
    window.JV.initializeModal();

    /**
     * Utility for making ajax calls on behalf of the modal services.Each call gets the template from the backend and triggers the corresponding controller and show the overlay.
     * @param {String} _url: Url where it should query for the templates.
     * @param {String} _controllerName: What is the controller name that should be triggered.
     * @param {String} _ajaxType: define the name of the ajax type which will be shown in the google analytics.
     * @param {Object} resultObjectToPassToController(Optional): Object required by the controller to render the information in the modal dialog. If passed this will become 
     *                                                          part of the 'results' property for the modal controller.
     * @param {serviceObject} : (optional) deferred Object, if passed will be available to the modal controller scope's "deferred" key. Its like a callback for the parent controller that is calling the modal.
     */
    function getModalAndTriggerController(_url, _controllerName, _ajaxType, resultObjectToPassToController, deferredService) {
        var requestObj = {
            url: _url,
            ajaxtype: _ajaxType,
            requestType: 'GET'
        };

        // get the template
        var _getModal = makeAjaxCall(requestObj);
        _getModal.then(function (results) {
            results = results.data;
            sourceModalAdapter.injectContentsInModal(results);
            var _element = angular.element('div[ng-controller="' + _controllerName + '"]');
            var _scope = _element.scope();
            // every modal controller will get the 'results' property by default which will be necessary to render the information.
            _scope.results = resultObjectToPassToController ?? {};
            if ((resultObjectToPassToController && typeof resultObjectToPassToController === 'object' && Object.keys(resultObjectToPassToController).length !== 0) ||
                (typeof resultObjectToPassToController === 'string' && resultObjectToPassToController.trim() !== '')) {
                _scope.results = resultObjectToPassToController;
            }
            // adding the defferred service property
            if (deferredService) {
                _scope.deferredService = deferredService;
            }
            $compile(_element)(_scope);
            _scope = _element.scope();
            // Show the modal now.
            sourceModalAdapter.showModal();
        });

    }


    // service method pings the backend for the select layout modal dialog box.
    modalService.getLayout = function (deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.layout, 'ModalSelectLayoutController', 'getLayoutOverlay', null, deferredService);
    };

    // service method pings the backend for the select layout modal dialog box.
    modalService.getWebLayout = function (deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.webLayout, 'ModalSelectLayoutController', 'getWebLayoutOverlay', null, deferredService);
    };

    //Scheduling a campaign with this modal dialog.
    modalService.getScheduleCampaign = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.scheduleCampaign, 'ModalScheduleCampaignController', 'getScheduleCampaignOverlay', results);
    };

    // Get the overlay for linking texts with the urls.
    modalService.getLinkDetails = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.linkDetails, 'ModalLinkDetailsController', 'getlinkDetailsOverlay', results, deferredService);
    };

    // Delete schedule email confirmation modal.
    modalService.getDeleteScheduleEmailConfirmation = function () {
        getModalAndTriggerController(MODAL_CONST.Urls.deleteScheduleEmail, 'DeleteScheduleEmailController', 'getdeleteScheduleEmailOverlay');
    };

    // Delete email confirmation.
    modalService.getDeleteEmailConfirmation = function () {
        getModalAndTriggerController(MODAL_CONST.Urls.deleteEmail, 'DeleteEmailController', 'getdeleteEmailOverlay');
    };

    // Delete campaign confirmation.
    modalService.getDeleteCampaignConfirmation = function (number) {
        getModalAndTriggerController(MODAL_CONST.Urls.deleteCampaign, 'DeleteCampaignController', 'getdeleteCampaignOverlay', number);
    };

    // Change status confirmation.
    modalService.changeStatusConfirmation = function () {
        getModalAndTriggerController(MODAL_CONST.Urls.changeStatus, 'ChangeStatusController', 'changeStatusOverlay');
    };

    // Can not schedule emails until the contacts are added to the campaign overlay.
    modalService.noScheduleEmailConfirmation = function () {
        getModalAndTriggerController(MODAL_CONST.Urls.noScheduleEmail, 'NoScheduleEmailConfirmController', 'noScheduleEmailOverlay');
    };

    // Removing contacts from campaign.
    modalService.removeContacts = function () {
        getModalAndTriggerController(MODAL_CONST.Urls.removeContacts, 'RemoveContactsController', 'removeContactsOverlay');
    };

    // Get the modal for selecting the requistions from the modal
    modalService.selectRequisition = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectRequisitions, 'addToReqController', 'selectRequsitionOverlay', results, deferredService);
    };

    // Get the modal for selecting the requistions from the modal
    modalService.selectCampaign = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectCampaign, 'selectCampaignsController', 'selectCampaignOverlay', results, deferredService);
    };

    // Get the modal for selecting the requistions from the modal
    modalService.selectWebCampaign = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectWebCampaign, 'selectWebCampaignsController', 'selectTypeOfCampaignOverlay', results, deferredService);
    };

    // Get the modal for selecting the requistions from the modal
    modalService.selectEmailCampaign = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectEmailCampaign, 'selectEmailCampaignsController', 'selectTypeOfCampaignOverlay', results, deferredService);
    };

    // Get the modal for selecting the requistions from the modal
    modalService.configureWidget = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.configureWidget, 'ModalTalentPoolWidget', 'configureTalentpoolWidget', results, deferredService);
    };

    modalService.selectFBAccount = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectFBAccount, 'SelectAccountController', 'selectAccountOverlay', results, deferredService);
    };

    modalService.getCampaignContacts = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.campaignContacts, 'CampaignContactsController', 'campaignContactsOverlay', results);
    };

    modalService.noCampaignContacts = function () {
        getModalAndTriggerController(MODAL_CONST.Urls.noCampaignContacts, 'NoCampaignContactsController', 'noCampaignContactsOverlay');
    };

    modalService.confirmCampaignContactsRemove = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.removeCampaignContacts, 'RemoveContactFromCampaignController', 'removeContactFromCampaignOverlay', results, deferredService);
    };

    modalService.showDummyiframe = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.getCampaignIframe, 'CampaignPreviewController', 'emailCampaignPreview', results);
    };

    modalService.cloneCampaign = function (results, deferredService) {
        getModalAndTriggerController(MODAL_CONST.Urls.cloneCampaign, 'CloneCampaignController', 'cloneCampaign', results, deferredService);
    };

    return modalService;
}]);

/**
 * Main modals controller. All the controllers are extending this controller. So put the common functionality here.
 * @param {Object} $scope
 */
AppCtrlModalsModule.controller('ModalsParentCtrl', ['$scope', 'sourceModalAdapter',
    function ($scope, sourceModalAdapter) {
        // close the overlay
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            this.$destroy();
        };
    }
]);


/**
 ** Campaign iframe preview for emails.
 */
AppCtrlModalsModule.controller('CampaignPreviewController', ['$scope',
    function ($scope) {
        $scope.$watch('results', function (newValue) {
            $scope.previewData = newValue.preview;
        });
    }
]);


AppCtrlModalsModule.controller('NoCampaignContactsController', ['$scope',
    function ($scope) {}
]);


AppCtrlModalsModule.controller('RemoveContactFromCampaignController', ['$scope',
    function ($scope) {
        $scope.remove = function () {
            // remove confirmed.
            $scope.deferredService.resolve(true);
            $scope.close();
        };
    }
]);

/**
 * Campaign contacts 
 * @param {Object} $scope
 */
AppCtrlModalsModule.controller('CampaignContactsController', ['$scope', 'actionModalService', '$routeParams',
    function ($scope, actionModalService, $routeParams) {
        // backend should return this value, right now defaulting it to 10
        $scope.pageCount = 10;
        $scope.page = 0;
        $scope.totalPages = 0;
        $scope.templateEid = null;
        $scope.$watch('results', function (newValue, oldValue) {
            if (!angular.isDefined(newValue)) {
                return;
            }
            $scope.templateEid = $scope.results.templateEid;
            $scope.page = $scope.results.page;
            $scope.contactList = $scope.results.resultList;
            if (window.gdprEnabled === 'true') {
                $scope.gdprEnabled = gdprEnabled;
                $scope.anonymizedContactCount = $scope.results.anonymizedCampaignMessageContactCount;
            }
            $scope.totalPages = Math.ceil($scope.results.resultCount / $scope.pageCount);
        });

        $scope.paginate = function (ifForward) {
            actionModalService.getCampaignContacts({
                page: ifForward ? $scope.page + 1 : $scope.page - 1,
                campaignEid: $routeParams.ceid,
                templateEid: $scope.templateEid
            }, function (results) {
                $scope.results = results;
            });
        };
    }
]);

/**
 * Controller for selecting the layout, triggers the event so that the controller for the tinymce injects the contents.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('ModalSelectLayoutController', ['$scope', '$rootScope',
    function ($scope, $rootScope) {
        // select the layout from the modal dialog.
        $scope.selectLayout = function (layout) {
            $scope.deferredService.resolve(layout);
            $scope.close();
        };
    }
]);

/**
 * Controller for scheduling the campaign.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('ModalScheduleCampaignController', ['$scope', '$rootScope', '$filter', 'campaignService', 'actionModalService', 'MODAL_CONST', '$routeParams', 'predefinedTemplates', 'Draggable', 'draggableTemplate', 'TinyMceMessageToContent', 'ContentToTinyMceMessage', 'sourceModalAdapter',
    function ($scope, $rootScope, $filter, campaignService, actionModalService, MODAL_CONST, $routeParams, predefinedTemplates, Draggable, draggableTemplate, TinyMceMessageToContent, ContentToTinyMceMessage, sourceModalAdapter) {
        $scope.sendTime = 'sendNow';
        $scope.showTinymce = false;
        $scope.pastEmailError = false;
        $scope.timeNotSelectedError = false;
        $scope.date = '';
        $scope.emailResults = [];
        $scope.scheduledTimeSelected = null;
        $scope.timeZoneSelected = null;
        $scope.formatEmail = function (item) {
            var subject = $filter('noHTML')(item.subject);
            var date = $filter('localeDateTime')(item.updateDate, 'shortTimestamp', 'MM/dd/yyyy h:mm a');
            return '<span class="select-email-subject">' + subject + '</span> <span class="select-email-create-date">' + date + '</span>';
        };

        $scope.sheduledTime = [{
                id: '8',
                text: i18n['JV_SOCIALMESSAGESTEMPLATE_MORNING']
            },
            {
                id: '12',
                text: i18n['JV_SOCIALMESSAGESTEMPLATE_AFTERNOON']
            },
            {
                id: '18',
                text: i18n['JV_SOCIALMESSAGESTEMPLATE_EVENING']
            }
        ];

        $scope.timeZone = [];
        actionModalService.getTimeZones({}, function (results) {
            $scope.timeZone = results.resultList;

        });

        //  $scope.$watch('results', function(newValue, oldValue){
        //      if(newValue === oldValue){
        //          return;
        //      }
        //  });

        $scope.showMoreContacts = false;
        $scope.showContacts = function () {
            $scope.showMoreContacts = true;
        };

        // save the schedule for campaign.

        $scope.save = function () {
            if ($scope.sendTime === 'sendFuture' && ($scope.date === null || $scope.date === undefined || $scope.date.trim() === '')) {
                $scope.timeNotSelectedError = true;
                return;
            }

            var saveObj = {
                'contentid': $scope.message.id,
                'campaignEId': $routeParams['ceid']
            };

            if (angular.isDefined($scope.results.ids)) {
                saveObj.contactEids = $scope.results.ids;
            }

            if ($scope.sendTime !== 'sendNow') {
                saveObj.schedule = $scope.date;
                saveObj.scheduleHour = parseInt($scope.scheduledTimeSelected['id']);
                saveObj.scheduleTimeZone = $scope.timeZoneSelected.openSysId;
            }

            sourceModalAdapter.hideModal();
            actionModalService.scheduleCampaign(saveObj, function (results) {
                if (results.status === 'ok') {
                    JV.showDropDownMessage(MODAL_CONST.strings.EMAILS_CONFIRMATION);
                } else {
                    // What to do if it fails?
                    JV.showDropDownMessageError(results.bean.message[0]);
                }
                if ($scope.results && $scope.results.selectedObjects) {
                    args.stripContents = true;
                }
                campaignService.getEmailContents(args);
            });
        };

        function getSelectedTimeZone(openSysId) {
            for (var i = 0; i < $scope.timeZone.length; i++) {
                if (openSysId === $scope.timeZone[i].openSysId) {
                    return $scope.timeZone[i];
                }
            }
            return null;
        }


        var args = {};
        /* While on the campaign contacts tab, we will have $scope.results.selectedObjects value and we want to show
         * Only the email contents that have not been sent, so we pass in the stripContents as true
         * But on the email contents tab, we want to show all emails
         */
        if ($scope.results && $scope.results.selectedObjects) {
            args.stripContents = true;
        }

        // make query for the email templates now and get the subjects from there.
        campaignService.getEmailContents(args);
        $scope.$on('emailContentsReceived', function (event, results) {
            $scope.emailResults = angular.copy(results.resultList);
            var predefined = [].concat(predefinedTemplates.User).concat(predefinedTemplates.Company);
            var allLinks;
            // change the message to the buttons
            angular.forEach($scope.emailResults, function (item) {
                allLinks = [];
                var metaData = JSON.parse(item.metaData);
                if (metaData != null && angular.isDefined(metaData) && metaData.actions != null && angular.isDefined(metaData.actions) && metaData.actions.length > 0) {
                    angular.forEach(metaData.actions, function (link) {
                        allLinks.push(Draggable(link.actionName, link.templateVariable, draggableTemplate));
                    });
                }
                if (metaData != null && angular.isDefined(metaData) && metaData.reqStructures) {
                    angular.forEach(metaData.reqStructures, function (reqStructure) {
                        if (reqStructure && angular.isDefined(reqStructure.jobTemplateVariable) && reqStructure.jobTemplateVariable && reqStructure.jobTemplateVariable.trim() !== '') {
                            allLinks.push(Draggable(reqStructure.jobTitle, reqStructure.jobTemplateVariable, draggableTemplate));
                        }
                    });
                }
                // do for the predefined templates.
                item.htmlMessage = ContentToTinyMceMessage(item.htmlMessage, predefined);
                item.htmlMessage = ContentToTinyMceMessage(item.htmlMessage, allLinks);
            });
            // if the results is specified change it to that.
            if (angular.isDefined($scope.results) && angular.isDefined($scope.results.id)) {
                var messageObj = {};
                for (var i = 0; i < results.resultList.length; i++) {
                    if (results.resultList[i].id === $scope.results.id) {
                        messageObj = results.resultList[i];
                    }
                }
                $scope.message = messageObj;
            } else {
                $scope.message = results.resultList[0];
            }
            try {
                $scope.message.from = JSON.parse($scope.message.metaData).fromLabel;
            } catch (e) {}

            $scope.timeZoneSelected = getSelectedTimeZone(results.userTimeZone);
        });

        $scope.$watch('message', function () {
            if ($scope.message) {
                try {
                    $scope.message.from = JSON.parse($scope.message.metaData).fromLabel;
                } catch (e) {}
            }
        });
    }
]);

/**
 * Controller for Linking text with the url.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('ModalLinkDetailsController', ['$scope',
    function ($scope) {
        $scope.linkObj = {};
        // linkText
        // linkUrl
        $scope.$watch('results', function (newValue, oldValue) {
            if (newValue === undefined) {
                return;
            }
            $scope.linkObj = $scope.results.metadata || {};
        });

        function checkAndShowValidations() {
            var emptyChecks = ['actionName', 'actionUrl'];
            var ifError = false;
            $scope.linkObj['actionNameError_quotes'] = false;
            $scope.linkObj['actionNameError_backslash'] = false;
            $scope.linkObj['actionNameError_tag'] = false;
            $scope.linkObj['actionNameError_duplicate'] = false;
            angular.forEach(emptyChecks, function (item) {
                $scope.linkObj[item + 'Error'] = false;
                //check for empty values.
                if ($scope.linkObj[item] === undefined || $scope.linkObj[item] === null || $scope.linkObj[item].trim() === '') {
                    $scope.linkObj[item + 'Error'] = true;
                    ifError = true;
                }
            });

            if ($scope.showMaxError === true) {
                ifError = true;
            }

            var name = $scope.linkObj.actionName;
            name = name.replace(/["]/g, '&quot;').replace('/\\/g', '\\');
            //($(name).html() !== undefined && $(name).html() !== null) failed in case of </input> which gets stripped by AntiSamy

            //Disallowing double quotes as they were causing issue while dragging the token even before saving it.
            if (name.indexOf('&quot;') > -1) {
                $scope.linkObj['actionNameError_quotes'] = true;
                ifError = true;
            }
            //Disallowing backslash in token name as AntiSamy strips names containing it
            else if (name.indexOf('\\') > -1) {
                $scope.linkObj['actionNameError_backslash'] = true;
                ifError = true;
            }
            /*Disallowing strings that have < but are not followed by space as AntiSamy strips such token names
             * 'Test <hello>' is stripped out but 'Test < hello>' with a space after < is not
             * 'Test </hello>' is stripped out but 'Test < /hello>' with a space after < is not
             */
            else if (/(<(\S)+)/.test(name)) {
                $scope.linkObj['actionNameError_tag'] = true;
                ifError = true;
            }

            //check for valid url
            if (!$scope.validateUrl($scope.linkObj.actionUrl)) {
                $scope.linkObj['actionUrlError'] = true;
                ifError = true;
            }
            if ($scope.results) {
                angular.forEach($scope.results.customTemplates, function (customTemplate) {
                    if (customTemplate && customTemplate.text && customTemplate.text === name) {
                        if (!$scope.results.currentLinkText) {
                            // Add custom template use case: Prevent duplicate name to be set
                            $scope.linkObj['actionNameError_duplicate'] = true;
                            ifError = true;
                        } else if ($scope.results.currentLinkText !== customTemplate.text) {
                            // Edit custom template use case: Prevent duplicate name to be set
                            $scope.linkObj['actionNameError_duplicate'] = true;
                            ifError = true;
                        }
                    }
                });
            }
            return ifError;
        }

        $scope.save = function () {
            if (checkAndShowValidations()) {
                return;
            }
            $scope.deferredService.resolve($scope.linkObj);
            $scope.close();
        };
    }
]);


/**
 * Controller for delete schedule email confirmation modal
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('DeleteScheduleEmailController', ['$scope',
    function ($scope) {}
]);

/**
 * Delete email confirmation Controller.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('DeleteEmailController', ['$scope',
    function ($scope) {}
]);

/**
 * Delete campaign confirmation Controller.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('DeleteCampaignController', ['$scope', '$rootScope', 'campaignService', 'sourceModalAdapter',
    function ($scope, $rootScope, campaignService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };

        $scope.deletes = function () {
            $rootScope.$broadcast('deleteCampaign');
            $scope.close();
        };
    }
]);

/**
 * Change status confirmation Controller.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('ChangeStatusController', ['$scope', '$rootScope', 'campaignService', 'sourceModalAdapter',
    function ($scope, $rootScope, campaignService, sourceModalAdapter) {
        $scope.noOfCampaigns = campaignService.noOfCampaigns;
        $scope.status = campaignService.status;
        $scope.buttonText = campaignService.buttonText;
        if ($scope.noOfCampaigns === 1) {
            $scope.text = i18n['JV_CAMPAIGNMODAL_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_STATUS_OF_THIS'].format($scope.status);
        } else {
            $scope.text = i18n['JV_CAMPAIGNMODAL_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_STATUS_OF_THES'].format($scope.noOfCampaigns, $scope.status);
        }

        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };

        $scope.changeStatus = function () {
            $rootScope.$broadcast('changeStatus');
            $scope.close();
        };
    }
]);

/**
 * Controller get triggered when user is trying to send emails in campaign with no contacts added.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('NoScheduleEmailConfirmController', ['$scope', '$rootScope',
    function ($scope, $rootScope) {}
]);

/**
 * Removes contacts from the campaign.
 * @param {Object} $scope
 * @param {Object} $rootScope
 */
AppCtrlModalsModule.controller('RemoveContactsController', ['$scope', '$rootScope',
    function ($scope, $rootScope) {}
]);


/**
 * Select requisition overlay modal controller.
 * @param {Object} $scope
 */
AppCtrlModalsModule.controller('addToReqController', ['$scope', 'actionModalService', '$rootScope',
    function ($scope, actionModalService, $rootScope) {
        // The directive needs this flag.
        $scope.flags = {
            loading: true
        };

        //Setting up add to Req modal configs
        var getmodalConfig = function (action) {
            switch (action) {
                case 'addToReq':
                    //Add to Req modal config
                    $scope.addToReqModalConfig = {
                        resetModalOn: 'modals.show',
                        list: {
                            config: {
                                type: 'singleSelect',
                                keyName: 'selectedReqEId',
                                label: i18n['LIST_MODAL_TEXT'],
                                tooltip: {
                                    show: false,
                                    text: 'Tooltip text goes here'
                                },
                                required: true,
                                errorText: i18n['MODAL_VALIDATION_TEXT'],
                                emptySearchText: i18n['FORMTEMPLATE_H_NO_RESULTS_FOUND_PLEASE_DO_ANOTHER_SEARCH'],
                                columns: [{
                                        header: i18n['REQUISITION'],
                                        show: true,
                                        key: ['title'],
                                        ellipsis: {
                                            set: true
                                        }
                                    },
                                    {
                                        header: i18n['ID'],
                                        show: true,
                                        key: ['requisitionId']
                                    },
                                    {
                                        header: i18n['STATUS'],
                                        show: true,
                                        key: ['jobState']
                                    },
                                    {
                                        header: i18n['COMPANY'],
                                        show: 'showCompany',
                                        key: ['subsidiary.name']
                                    },
                                    {
                                        header: i18n['CATEGORY'],
                                        show: true,
                                        key: ['category.name'],
                                        ellipsis: {
                                            set: true
                                        }
                                    },
                                    {
                                        header: i18n['LOCATION'],
                                        show: true,
                                        key: ['location.name'],
                                        ellipsis: {
                                            set: true
                                        },
                                        tooltipShow: 'jobLocations',
                                        tooltipTriggerLength: 'jobLocations',
                                        tooltipTriggerClass: 'italic',
                                        tooltipBodyList: 'jobLocations',
                                        tooltipBodyListId: ['name']
                                    }
                                ]
                            },
                            get: $scope.listGetObject,
                            post: {
                                callBack: $scope.addToReqCallback,
                                button: {
                                    label: i18n['SELECT'],
                                    type: 'button',
                                    classNames: ['blue-btn', 'float-right'],
                                    id: 'addToReq-btn'
                                }
                            },
                            filters: [{
                                    label: i18n['STATUS'],
                                    ghostText: i18n['ALL'],
                                    width: 'w230',
                                    allowClear: true,
                                    data: $scope.statusFilter,
                                    keyName: 'reqsStatusFilter',
                                    defaultTo: JSON.stringify($scope.statusFilter.filter(function (filter) {
                                        return (filter.key === 1 && filter.mine === false);
                                    }).pop())
                                },
                                {
                                    label: i18n['CATEGORY'],
                                    ghostText: i18n['ALL'],
                                    width: 'w260',
                                    allowClear: true,
                                    data: $scope.categoriesFilter,
                                    keyName: 'reqsCategoryFilter'
                                    //responseKey: 'filters.Categories'
                                }

                            ],
                            search: {
                                label: i18n['SEARCH'],
                                placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                                get: {
                                    url: '/jhire/action/requisitions?'
                                }
                            }
                        }
                    };
                    return $scope.addToReqModalConfig;
                default:
            }
        };
        $scope.$watch('results', function (newValue) {
            if (angular.isDefined(newValue) && angular.isDefined(newValue.allStatusFilter)) {
                $scope.statusFilter = $scope.results.allStatusFilter.optionValues;
                $scope.categoriesFilter = $scope.results.filters.Categories;
            }
            setupFormTemplateConfig('addToReq');
        });

        $scope.addToReqCallback = function (data) {
            $scope.close();
            // get the req object and pass it on to the promise.
            if (data.items !== undefined) {
                for (var i = 0, j = data.items.length; i < j; i++) {
                    if (data.items[i].EId === data.selectedReqEId) {
                        $scope.deferredService.resolve(data.items[i]);
                        break;
                    }
                }
            }
        };

        var setupFormTemplateConfig = function (action) {
            $scope.listGetObject = {
                url: '/jhire/action/requisitions?',
                params: {
                    page: '0',
                    q: '',
                    maxResults: '10',
                    mine: false
                },
                responseKey: 'jobs'
            };
            $scope.formTemplateConfig = getmodalConfig(action);
        };
    }
]);

AppCtrlModalsModule.controller('ModalTalentPoolWidget', ['$scope', 'campaignService', 'contactDetailsService', '$localStorage',
    function ($scope, campaignService, contactDetailsService, $localStorage) {
        var _sourceId, _contactStatusId;
        var customFieldPromise = campaignService.getCustomFieldsList();
        var textSourceDetails = ['Email', 'JobBoard', 'ResumeSearch', 'FederatedSearch', 'CustomWithName'];
        var dropdownSourceDetails = ['Agency', 'EnteredByHiringManager', 'EnteredByRecruiter', 'Referral'];
        $scope.talentpool = {};
        $scope.talentpool.linkedInProfile = true;
        $scope.talentpool.facebookConnect = true;
        $scope.talentpool.attachResume = true;
        $scope.talentpool.fluidWidth = true;
        $scope.talentpool.displayLocation = true;
        $scope.talentpool.sendJobAlerts = true;
        $scope.jobAlertsLocationRequired = jobAlertsLocationRequired;
        $scope.optionalFields = {
            phoneNumber: true,
            companyName: true,
            jobTitle: true,
            jobsOfInterest: true
        };
        $scope.customFields = {
            0: null,
            1: null,
            2: null,
            3: null
        };
        $scope.availableCustomFields = [];
        customFieldPromise.then(function (data) {
            if (data && data.bean && data.bean.Fields) {
                $scope.availableCustomFields = data.bean.Fields;
            }
        });
        $scope.disableJuaUpgradeAlert = $localStorage.jvDisableJuaUpgradeAlert;
        $scope.$watch('disableJuaUpgradeAlert', function (val) {
            if (val) {
                $localStorage.jvDisableJuaUpgradeAlert = 1;
            }
        });
        $scope.$watch('results', function (val) {
            if (!angular.isUndefined(val)) {
                angular.extend($scope.talentpool, {
                    tags: []
                }, val);
                _sourceId = $scope.talentpool.source;
                _contactStatusId = ($scope.talentpool.contactStatus === null ? null : Number($scope.talentpool.contactStatus));
                var _tags = [];
                if (!!$scope.talentpool.tags && $scope.talentpool.tags.length > 0) {
                    $.each($scope.talentpool.tags, function (index, value) {
                        //Decoding the tag value for showing in the UI
                        _tags.push(decodeURIComponent(value));
                    });
                }
                $scope.talentpool.tags = _tags.join(',');
                // initialize the starting value of tagsLength
                $scope.talentpool.tagsLength = $scope.talentpool.tags.length;

                if (!!$scope.talentpool.notes && $scope.talentpool.notes.trim() !== '') {
                    //Decoding the notes for showing in the UI
                    $scope.talentpool.notes = decodeURIComponent($scope.talentpool.notes);
                }
                if ($scope.talentpool.sourceDetail) {
                    $scope.talentpool.sourceDetail = decodeURIComponent($scope.talentpool.sourceDetail);
                }
                if ($scope.talentpool.optionalFields) {
                    // convert array to object for FE
                    $scope.optionalFields = mapOptionalFields($scope.talentpool.optionalFields);
                }
                if (val.widgetCustomFields) {
                    customFieldPromise.then(function () {
                        // convert array to object for FE
                        // extend to preserve default checked state
                        angular.extend($scope.customFields, mapCustomFields(val.widgetCustomFields));
                    });
                }
            }
        });

        angular.extend($scope.talentpool, $scope.results);

        $scope.tagSelect = contactDetailsService.tagSelect;

        $scope.updateTags = function () {
            $scope.talentpool.tags = $scope.tags.join(',');
        };

        $scope.save = function () {
            if ($scope.talentpool.notestagRemaining < 0 || $scope.talentpool.descriptionRemaining < 0 || $scope.talentpool.titleRemaining < 0) {
                return;
            }

            var tmpTalentpool = angular.copy($scope.talentpool);
            var tagArray = [];

            // transform the tags objects into a comma separated list for persisting
            $.each($('#jv-tags').select2('data'), function (index, value) {
                tagArray.push(value.text);
            });

            var _encodedTagArray = [];
            if (!!tagArray && tagArray.length > 0) {
                $.each(tagArray, function (index, value) {
                    _encodedTagArray.push(encodeURIComponent(value));
                });
            }
            tmpTalentpool.tags = _encodedTagArray;
            if (!!tmpTalentpool.notes && tmpTalentpool.notes.trim() !== '') {
                tmpTalentpool.notes = encodeURIComponent(tmpTalentpool.notes);
            }
            tmpTalentpool.contactStatus = ((tmpTalentpool.contactStatus || {}).id || 0).toString();
            tmpTalentpool.source = (tmpTalentpool.source || {}).eid || null;
            tmpTalentpool.sourceDetailEId = (angular.isObject(tmpTalentpool.sourceDetailEId)) ? tmpTalentpool.sourceDetailEId.eid || tmpTalentpool.sourceDetailEId.EId : tmpTalentpool.sourceDetailEId;
            if (tmpTalentpool.sourceDetail) {
                tmpTalentpool.sourceDetail = encodeURIComponent(tmpTalentpool.sourceDetail);
            }
            if (tmpTalentpool.campaignObj) {
                tmpTalentpool.campaign = tmpTalentpool.campaignObj.eid;
            }
            $scope.deferredService.resolve(tmpTalentpool);
            $scope.mainClose();
        };

        $scope.clearCampaign = function () {
            $scope.talentpool.campaignObj = !$scope.talentpool.campaignObj;
            $scope.talentpool.campaign = '';
        };

        var mapOptionalFields = function (selectedFields) {
            var map = {};
            selectedFields.forEach(function (field) {
                map[field] = true;
            });
            return map;
        };

        var unmapFields = function (map, extractFn) {
            return Object.keys(map).map(extractFn).filter(function (val) {
                return val;
            });
        };

        var mapCustomFields = function (selectedFields) {
            var map = {};
            selectedFields.forEach(function (internalName, index) {
                map[index] = $scope.availableCustomFields.filter(function (field) {
                    return (field.internalName === internalName.name);
                }).pop();
                map[index].required = internalName.required;
            });
            return map;
        };

        var loadContactStatuses = function () {
            campaignService.getContactStatuses({}, function (results) {
                var contactStatuses = [];
                angular.forEach(results.data.resultList, function (x) {
                    x.sid = x.id + '';
                    contactStatuses.push(x);
                    if (x.id === _contactStatusId) {
                        $scope.talentpool.contactStatus = x;
                    }
                });
                $scope.contactStatuses = contactStatuses;
            });
        };
        $scope.talentpool.contactStatus = null;
        $scope.talentpool.source = null;
        loadContactStatuses();
        var loadSources = function () {
            var sources = [];
            campaignService.getContactSources({}, function (results) {
                var sources = [];
                angular.forEach(results.data.resultList, function (x) {
                    sources.push(x);
                    if (x.eid === _sourceId) {
                        $scope.talentpool.source = x;
                        if (x.sources) {
                            $scope.talentpool.sourceDetailEId = x.sources.filter(function (detail) {
                                return (detail.eid === $scope.talentpool.sourceDetailEId);
                            }).pop();
                        }
                    }
                });
                $scope.sources = sources;
            });
            return sources;
        };
        $scope.sources = loadSources();
        $scope.includeSrc = 'campaign2/modals/selectEmailCampaign.html';
        $scope.loadCampaign = false;
        $scope.showCampaigns = false;
        $scope.mainClose = $scope.close;
        $scope.activeModal = 'jvTPWConfigure';

        $scope.loadCampaignScreen = function () {
            $scope.showCampaigns = true;
            $scope.loadCampaign = true;
            $scope.activeModal = 'jvTPWSelectCampaign';
        };

        $scope.select = function (campaignObj) {
            $scope.showCampaigns = false;
            $scope.loadCampaign = false;
            $scope.activeModal = 'jvTPWConfigure';
            if (campaignObj) {
                $scope.talentpool.campaignObj = campaignObj;
                $scope.talentpool.campaignName = campaignObj.name;
                $scope.talentpool.campaign = campaignObj.id;
            }
        };
        $scope.$watch('optionalFields', function (val) {
            if (val) {
                // convert object to array for BE
                $scope.talentpool.optionalFields = unmapFields(val, function (key) {
                    if (val[key]) {
                        return key;
                    }
                });
            }
        }, true);
        $scope.$watch('customFields', function (val) {
            if (val) {
                // convert object to array for BE
                $scope.talentpool.widgetCustomFields = unmapFields(val, function (key) {
                    if (val[key] && val[key].internalName) {
                        return {
                            name: val[key].internalName,
                            required: val[key].required
                        };
                    }
                });
            }
        }, true);
        $scope.$watch('talentpool.source', function (source, prev) {
            if (source) {
                if (angular.isObject(prev)) {
                    // clear only when switching sources
                    // `prev` is string when initially loaded
                    $scope.talentpool.sourceDetail = null;
                    $scope.talentpool.sourceDetailEId = null;
                }
                if (dropdownSourceDetails.indexOf(source.type) > -1 || (source.type === 'Custom' && source.sources)) {
                    $scope.sourceDetailsType = source.type.toLowerCase();
                } else if (textSourceDetails.indexOf(source.type) > -1) {
                    $scope.sourceDetailsType = 'text';
                } else {
                    $scope.sourceDetailsType = null;
                }
            } else {
                $scope.sourceDetailsType = null;
            }
        });
        $scope.$watch('talentpool.sourceDetailEId', function (val) {
            // watch for custom and employee type sources
            if (val && angular.isObject(val)) {
                $scope.talentpool.sourceDetail = val.name || val.fullName;
            }
        });
    }
]);


AppCtrlModalsModule.controller('selectWebCampaignsController', ['$scope', 'campaignService',
    function ($scope, campaignService) {
        var firstRun = true;

        function search() {
            var args = {
                page: $scope.page,
                keywords: $scope.query,
                status: 'IN_PROGRESS',
                maxResults: 10
            };

            function resetScope(results) {
                $scope.campaigns = results.resultList;
                $scope.start = (results.page * results.pageCount) + 1;
                $scope.end = (results.page + 1) * results.pageCount;
                $scope.totalNumber = results.resultCount;
                $scope.page = results.page;
                $scope.totalPages = Math.ceil($scope.totalNumber / $scope.campaigns.length);
                if (!firstRun) {
                    ($scope._resize || angular.noop)();
                }
                firstRun = false;
            }
            angular.extend(args, {
                type: 'WEBSITE',
                hasContentFlag: true
            });
            campaignService.getCampaignsNoBroadcast(args, resetScope);
        }

        $scope.query = '';
        $scope.page = 0;
        $scope.selectedCampaign = {
            index: ''
        };

        $scope.$watch('selectedCampaign.index', function (newVal) {
            if (newVal) {
                angular.forEach($scope.campaigns, function (campaign) {
                    if (campaign.eid === newVal) {
                        $scope.campaignObj = campaign;
                    }
                });
            }
        });

        if (!$scope.select) {
            $scope.select = function (campaignObj) {
                $scope.deferredService.resolve(campaignObj);
                $scope.close();
            };
        }

        $scope.search = function () {
            $scope.page = 0;
            search();
        };

        $scope.paginate = function (forward) {
            if (forward) {
                $scope.page++;
            } else {
                $scope.page--;
            }
            search();
        };
        search();
    }
]);

AppCtrlModalsModule.controller('selectEmailCampaignsController', ['$scope', 'campaignService',
    function ($scope, campaignService) {
        var firstRun = true;

        function search() {
            var args = {
                page: $scope.page,
                keywords: $scope.query,
                status: 'IN_PROGRESS',
                maxResults: 10
            };

            function resetScope(results) {
                $scope.campaigns = results.resultList;
                $scope.start = (results.page * results.pageCount) + 1;
                $scope.end = (results.page + 1) * results.pageCount;
                $scope.totalNumber = results.resultCount;
                $scope.page = results.page;
                $scope.totalPages = Math.ceil($scope.totalNumber / $scope.campaigns.length);
                if (!firstRun) {
                    ($scope._resize || angular.noop)();
                }
                firstRun = false;
            }
            angular.extend(args, {
                type: 'EMAIL',
                hasContentFlag: false
            });
            campaignService.getCampaignsNoBroadcast(args, resetScope);
        }

        $scope.query = '';
        $scope.page = 0;
        $scope.selectedCampaign = {
            index: ''
        };

        $scope.$watch('selectedCampaign.index', function (newVal) {
            if (newVal) {
                angular.forEach($scope.campaigns, function (campaign) {
                    if (campaign.eid === newVal) {
                        $scope.campaignObj = campaign;
                    }
                });
            }
        });

        if (!$scope.select) {
            $scope.select = function (campaignObj) {
                $scope.deferredService.resolve(campaignObj);
                $scope.close();
            };
        }

        $scope.search = function () {
            $scope.page = 0;
            search();
        };

        $scope.paginate = function (forward) {
            if (forward) {
                $scope.page++;
            } else {
                $scope.page--;
            }
            search();
        };
        search();
    }
]);

AppCtrlModalsModule.controller('SelectCampaignsController', ['$scope', 'actionModalService',
    function ($scope, actionModalService) {
        function makeCallback(args) {
            actionModalService.selectCampaign({
                page: $scope.page,
                q: $scope.queryString
            }, function (results) {
                $scope.campaigns = results.campaigns;
                $scope.start = results.startNumber;
                $scope.end = results.endNumber;
                $scope.totalNumber = results.totalNumber;
                $scope.page = results.page;
            });
        }

        $scope.selectedCampaign = {
            index: ''
        };

        $scope.$watch('selectedCampaign.index', function (newVal) {
            if (newVal) {
                angular.forEach($scope.campaigns, function (campaign) {
                    if (campaign.id === newVal) {
                        $scope.campaignObj = campaign;
                    }
                });
            }
        });

        $scope.search = function () {
            $scope.page = 1;
            makeCallback();
        };

        $scope.paginate = function (forward) {
            if (forward) {
                $scope.page++;
            } else {
                $scope.page--;
            }
            makeCallback();
        };
        makeCallback();
    }
]);

AppCtrlModalsModule.controller('SelectAccountController', ['$scope',
    function ($scope) {
        $scope.select = function () {
            var selectedAccounts = [];
            angular.forEach($scope.results, function (account) {
                if (account.selected) {
                    account.status = 'ACTIVE';
                    selectedAccounts.push(account);
                }
            });

            if (selectedAccounts.length > 0) {
                $scope.deferredService.resolve(selectedAccounts);
            } else {
                $scope.deferredService.reject(i18n['JV_CAMPAIGNMODAL_NO_ACCOUNTS_SELECTED']);
            }
            $scope.close();
        };
    }
]);

AppCtrlModalsModule.controller('CloneCampaignController', ['$scope', 'campaignService',
    function ($scope, campaignService) {
        $scope.clonedCampaign = {};
        $scope.save = function () {
            $scope.clonedCampaign.eid = $scope.results.eid;
            $scope.error = null;
            $scope.saving = true;
            campaignService.cloneCampaign($scope.clonedCampaign).then(function (results) {
                if (results && results.status === 'ok') {
                    $scope.close();
                    $scope.deferredService.resolve(results.bean);
                } else if (results.error) {
                    $scope.error = results.bean.name[0];
                } else {
                    $scope.deferredService.reject();
                }
                $scope.saving = false;
            }, function () {
                $scope.deferredService.reject();
                $scope.saving = false;
            });
        };
    }
]);

// monkey-patch show/hideModal to add/remove class on body
// (function() {
//     var oldHideModal = sourceModalAdapter.hideModal;
//     sourceModalAdapter.hideModal = function() {
//         angular.element(document.body).removeClass('jv-modal-visible');
//         oldHideModal.apply(JV, arguments);
//     };
//     var oldShowModal = JV.showModal;
//     JV.showModal = function() {
//         angular.element(document.body).addClass('jv-modal-visible');
//         $(window).scrollTop(0); // scroll to top so select2 is positioned correctly
//         oldShowModal.apply(JV, arguments);
//     };
// })();